import {
	Directive,
	ElementRef,
	EventEmitter,
	Output,
	Renderer2,
} from "@angular/core";

@Directive({
	selector: "[appInfiniteScroll]",
})
export class InfiniteScrollDirective {
	@Output() scrolledToBottom = new EventEmitter<void>();

	private scrollableBody!: HTMLElement;

	constructor(private el: ElementRef, private renderer: Renderer2) {}

	ngAfterViewInit() {
		setTimeout(() => {
			this.scrollableBody = this.el.nativeElement.querySelector(
				".p-datatable-scrollable-body"
			);

			if (!this.scrollableBody) {
				console.warn(
					"⚠️ Tidak ditemukan elemen .p-datatable-scrollable-body!"
				);
				return;
			}

			this.renderer.listen(this.scrollableBody, "scroll", () => {
				if (
					this.scrollableBody.scrollTop +
						this.scrollableBody.clientHeight >=
					this.scrollableBody.scrollHeight
				) {
					console.log("🔥 Scroll sampai bawah di directive!");
					this.scrolledToBottom.emit();
				}
			});
		}, 0);
	}
}
